import React, { useState } from "react";
// import logo from "assets/img/logo_z_obwodka.png";
import axios from "axios";
import { saveAs } from "file-saver";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ModuleNavbar = (props) => {
  const {
    title,
    color,
    gradient = null,
    func,
    icon = "nc-icon nc-bookmark-2",
    page = 1,
  } = props;
  const [helpModal, setHelp] = useState(false);
  const toggleHelp = () => setHelp(!helpModal);
  // var gradient = 'linear-gradient(to right, #fff 0%, '+color+ ')'
  const downloadGuide = async (object) => {
    const config = {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "pdf",
      },
    };
    try {
      const res = await axios.get(process.env.REACT_APP_GET_GUIDE, config);
      let blob = new Blob([res.data], {
        type: "application/pdf",
      });
      const fileURL = URL.createObjectURL(blob);
      //Open the URL on new Window
      const pdfWindow = window.open();
      pdfWindow.location.href = fileURL + "#page=" + page;
    } catch (err) {
      console.log("error: ", JSON.stringify(err));
    }
  };
  return (
    <div className="moduleNavbar">
      <nav
        className={"modNav" + " " + title.split(" ")[0]}
        style={{ borderBottom: "2px solid " + color }}
      >
        <div className="modNavColor" style={{ backgroundColor: color }}>
          <i className={icon} />
          <span> {title} </span>
        </div>
        <div>
          <span className="modNavOptions">
            <span tabIndex={'0'} role={'button'}
                  className="clickable"
                  onClick={(e) => {
                    func();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      func();
                    }
                  }}
            >
              przewodnik
            </span>
            <span tabIndex={'0'} role={'button'}
                  className="clickable"
                  onClick={(e) => {
                    downloadGuide();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      downloadGuide();
                    }
                  }}
            >
              instrukcja
            </span>
            <span tabIndex={'0'} role={'button'} className="clickable" onClick={(e) => toggleHelp()}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      toggleHelp()
                    }
                  }}
            >
              pomoc
            </span>
          </span>
        </div>
      </nav>

      <Modal className={"modal-md"} isOpen={helpModal} toggle={toggleHelp}>
        <ModalHeader>Wsparcie techniczne i merytoryczne</ModalHeader>
        <ModalBody className="text-justify">
          Wszelkie problemy techniczne w związku z działaniem aplikacji tj. błąd
          logowania, zapomniane hasło itp., należy kierować na adres email:{" "}
          <span style={{ color: "#17728d", fontWeight: "bold" }}>
            srk@aotm.gov.pl
          </span>
          .<br />
          W treści wiadomości proszę opisać problem jaki wystąpił oraz
          preferowaną drogę kontaktu (w przypadku kontaktu innego niż mail,
          należy podać dane do&nbsp;kontaktu). <br />
          <br />
          {/* <strong>Wsparcie techniczne</strong> telefon kontaktowy <span style={{color:'#17728d', fontWeight: 'bold'}}>
                    +48 22 101 47 74</span> w godzinach 8.00 - 16.00 (dni robocze).  <br /><br /> */}
          <strong>Wsparcie merytoryczne</strong> telefon kontaktowy :
          <span style={{ color: "#17728d", fontWeight: "bold" }}>
            {" "}
            459 588 942
          </span>{" "}
          lub
          <span style={{ color: "#17728d", fontWeight: "bold" }}>
            {" "}
            459 588 943
          </span>{" "}
          w&nbsp;godzinach 8.00 - 16.00 (dni robocze).
          <br />
          <br />
          <strong>Film instruktażowy</strong> w postaci demo znajduje się
          na&nbsp;kanale YouTube Agencji Oceny Technologii Medycznych
          i&nbsp;Taryfikacji:&nbsp;
          <span
            className="linkDemo"
            onClick={(e) => {
              window.open(
                "https://www.youtube.com/watch?v=q6lXrYGO0EA",
                "_blank"
              );
            }}
          >
            przejdź do demo
          </span>
          .
        </ModalBody>
        <ModalFooter>
          <Button
            color="link"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleHelp()}
          >
            Zamknij
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModuleNavbar;
